import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Select from "../components/form/Select";
import Checkbox from "../components/form/Checkbox";
import Button from "../components/form/Button";
import { Link } from 'react-router-dom';
import toastr from "toastr";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { authLogin } from "../store/authSlice";

import { postData } from "../services/api";

const Signup = () => {
    setTitle("Radisol | Signup");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [industries,setIndustries] = useState([]);

    const [company_name,setCompanyName] = useState('');
    const [industry,setIndustry] = useState('');
    const [number_of_employees,setNumberOfEmployees] = useState('');
    const [email, setEmail] = useState("");
    const [password,setPassword] = useState('');
    const [otp,setOtp] = useState('');
    const [isCheck,setIsCheck] = useState(1);
    const [isSignup,setIsSignup] = useState(false);
    const [isVerify,setIsVerify] = useState(false);
    const [isResendOtp,setIsResendOtp] = useState(false);
    const [countDown,setCountDown] = useState('(00:00)');
    const [isDisabled,setIsDisabled] = useState(false);

    useEffect(() => {
      async function industryData() {
        try {
          const result = await postData("industry/list", {});
          if (result.data) {
            setIndustries(result.data);
          } else {
            console.log('industry list message',result.message)
          }
        } catch (error) {
          console.log('Error industry list catch',error.message)
        }
      }
      industryData();        
    }, []);

    const onSubmit = async (e) => {
      e.preventDefault();
      setIsSignup(true);
      try {
        const userData = await postData("signup", {
          name : company_name,
          industry: industry,
          number_of_employees:number_of_employees,
          email: email,
          password: password,
        });
        if (userData.status && userData.status === 200) {
          setIsSignup(false);
          setIsCheck(2);
          otpCounter();
          toastr.success(userData.message);
        } else {
          toastr.error(userData.message);
          setIsSignup(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsSignup(false);
      }
    };
    
    const onVerify = async (e) => {
      e.preventDefault();
      setIsVerify(true);
      try {
        const userData = await postData("account-verification", {
          email: email,
          otp : otp,
        });
        if (userData.status && userData.status === 200) {
          setIsVerify(false);
          dispatch(authLogin(userData.data));
          localStorage.setItem("accessToken", userData?.accessToken);
          localStorage.setItem("role", userData?.data?.code);
          toastr.success(userData.message);
          return navigate("/dashboard");
        } else {
          toastr.error(userData.message);
          setIsVerify(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsVerify(false);
      }
    };

    const onResendOtp = async (e) => {
      e.preventDefault();
      setIsResendOtp(true);
      try {
        const userData = await postData("resend-otp", {
          email: email,
        });
        if (userData.status && userData.status === 200) {
          setIsResendOtp(false);
          otpCounter();
          toastr.success(userData.message);
        } else {
          toastr.error(userData.message);
          setIsResendOtp(false);
        }
      } catch (error) {
        toastr.error(error.message);
        setIsResendOtp(false);
      }
    };

    const otpCounter = () => {
      setIsDisabled(true);
      const count_time5 = add_minutes(new Date(), 0.5).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
      const count_time20 = new Date(count_time5).getTime();
      const x20 = setInterval(function() {
        const timezone20 = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
        const now20 = new Date(timezone20).getTime();
        const distance20 = count_time20 - now20;
        const days20 = Math.floor(distance20 / (1000 * 60 * 60 * 24));
        const hours20 = Math.floor((distance20 % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes20 = Math.floor((distance20 % (1000 * 60 * 60)) / (1000 * 60));
        const seconds20 = Math.floor((distance20 % (1000 * 60)) / 1000);
        // Output the result in an element with id="demo"
        setCountDown('('+ ('0'+minutes20).slice(-2) + ":" + ('0'+seconds20).slice(-2) +')');
        //console.log('('+ ('0'+minutes20).slice(-2) + ":" + ('0'+seconds20).slice(-2) +')');
        // If the count down is over, write some text 
        if (distance20 < 0) {
            clearInterval(x20);
            setCountDown('(00:00)');
            setIsDisabled(false);
        }
      }, 1000);
    } 
    
    const add_minutes = (dt2, minutes2) => {
      return new Date(dt2.getTime() + minutes2*60000);
    }

    return (
        <>
          <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
            <div className="w-full max-w-sm">
              <div className="h-10 w-full flex justify-center object-contain mb-5">
                <svg className="h-full" preserveAspectRatio="xMidYMid meet" data-bbox="0 0 382.89 71.37" viewBox="0 0 382.89 71.37" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-iz595q-x7t6i4"><title id="svgcid-iz595q-x7t6i4">Radisol Logo</title><g><path d="m21.02 40.95-6.88-2.98c-3.78-1.61-4.59-3.29-4.59-6.01s1.05-5.15 5.08-5.15c3.41 0 4.84 2.42 4.84 6.57h8.56v-1.24c0-8.49-5.77-11.9-13.7-11.9-8.44 0-13.71 4.4-13.71 13.02 0 7.38 3.66 10.66 11.59 13.39 5.89 2.05 7.94 3.53 7.94 7.56 0 3.72-2.6 5.46-5.33 5.46-4.71 0-5.89-2.67-5.89-6.82v-1.3H0v1.8c0 8.18 3.97 12.9 14.07 12.9s15.38-4.22 15.38-13.58c0-5.39-1.74-8.8-8.43-11.72Z" fill="#3a8078" data-color="1"></path><path d="M49.45 54.15c0 3.72-1.61 5.52-4.53 5.52-2.54 0-3.66-1.3-3.66-4.65v-23H32.7v24.74c0 6.57 3.16 9.49 8.49 9.49 3.6 0 6.7-1.49 8.49-4.77h.12v3.91h8.18V32.02h-8.56v22.13Z" fill="#3a8078" data-color="1"></path><path d="M75.18 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M103.19 37.35c3.22 0 3.84 3.47 3.84 6.7h8.18c0-7.87-4.09-12.9-11.97-12.9s-13.52 3.84-13.52 17.54 4.22 17.55 12.77 17.55c9.05 0 12.71-4.9 12.71-13.64h-8.18c0 5.39-1.3 7.81-4.15 7.81-3.84 0-4.59-3.41-4.59-11.66 0-7.69.68-11.41 4.9-11.41Z" fill="#3a8078" data-color="1"></path><path d="M131.01 31.15c-11.53 0-13.27 8.31-13.27 17.24 0 8.31.5 17.85 12.9 17.85 8.06 0 11.78-4.34 12.09-12.09h-7.69c-.5 4.09-1.67 6.26-4.53 6.26-3.16 0-4.22-3.84-4.22-7.75v-2.67h16.92v-1.92c0-10.23-2.23-16.93-12.21-16.93Zm-4.71 13.76v-1.3c0-3.1.99-6.63 4.4-6.63s4.15 2.85 4.34 7.94h-8.74Z" fill="#3a8078" data-color="1"></path><path d="m162.72 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path d="m189.75 46.22-5.15-1.74c-2.85-.93-3.72-2.29-3.72-3.91 0-2.36 1.86-3.6 4.03-3.6 2.79 0 3.78 1.67 3.78 5.02h7.69v-1.36c0-6.01-3.66-9.49-11.41-9.49-8.8 0-12.28 4.53-12.28 10.04 0 4.71 2.42 7.63 7.13 9.3l6.01 2.17c1.67.62 3.1 1.61 3.1 3.78 0 2.67-1.74 3.97-4.34 3.97-2.91 0-4.46-1.92-4.46-4.84v-1.12h-7.69v1.18c0 6.39 2.67 10.6 12.28 10.6 7.19 0 12.4-3.47 12.4-10.48 0-5.02-1.98-7.75-7.38-9.55Z" fill="#3a8078" data-color="1"></path><path fill="#3a8078" d="M209.32 20.61v7.32h-8.56v-7.32h8.56z" data-color="1"></path><path fill="#3a8078" d="M209.32 32.02v33.35h-8.56V32.02h8.56z" data-color="1"></path><path d="M226.36 31.15c-9.8 0-13.14 6.14-13.14 17.54s2.85 17.73 13.14 17.55c9.8 0 13.14-6.14 13.14-17.55s-2.85-17.73-13.14-17.54Zm0 29.26c-4.22 0-4.59-4.9-4.59-11.72s.37-11.72 4.59-11.72c3.47 0 4.59 3.41 4.59 11.72s-1.12 11.72-4.59 11.72Z" fill="#3a8078" data-color="1"></path><path d="M260 31.15c-3.6 0-6.7 1.49-8.49 4.77h-.12v-3.91h-8.18v33.35h8.56V43.23c0-3.72 1.61-5.52 4.53-5.52 2.54 0 3.66 1.3 3.66 4.65v23h8.56V40.62c0-6.57-3.16-9.49-8.49-9.49Z" fill="#3a8078" data-color="1"></path><path d="M325.74 31.15c-9.8 0-14.45 6.14-16.86 17.54-2.48 11.59-.93 17.73 9.42 17.55 9.79 0 14.45-6.14 16.86-17.55 2.48-11.59.93-17.73-9.42-17.54Zm.87 17.54c-1.74 8.31-3.6 11.72-7.07 11.72-4.21 0-3.53-4.9-2.11-11.72 1.49-6.82 2.85-11.72 7.07-11.72 3.47 0 3.91 3.41 2.11 11.72Z" fill="#a7a9ac" data-color="2"></path><path fill="#a7a9ac" d="m374.7 32.02-9.05 23.68h-.12l.62-23.68h-9.3l-9.18 23.68h-.12l1.11-23.68h-8.55l.18 33.35h9.92l9.18-23.68h.12l-.62 23.68h9.74l14.26-33.35h-8.19z" data-color="2"></path><path fill="#a7a9ac" d="M321.29 12.82 313.02 0 300.2 8.27l6.29 1.36-11.16 41.79h-.13l-5.34-23.31h-10.29l-9.42 43.26h8.18l6.57-29.99h.13l5.34 23.99h10.16l14.2-53.96 6.56 1.41z" data-color="2"></path></g></svg>
              </div>
              {/* <div className="w-full mb-5 text-center space-y-2">
                <div className="text-slate-500 text-xl font-extralight leading-none">President/Chief Executive Officer Succession Plan</div>
                <div className="text-sm text-slate-900 font-bold">Yankee Federal Credit Union</div>
              </div> */}
              <div className="w-full bg-white rounded shadow-md py-8 px-6">
                {
                  (isCheck && isCheck === 1)?
                  <div className="divide-y divide-slate-200 space-y-4">
                      <div className="relative">
                          <h1 className="text-xl font-semibold text-center text-slate-700">
                          Signup
                          </h1>
                          <div className="text-sm text-slate-400 text-center font-light">
                          Please use your credentials to signup
                          </div>
                      </div>
                      <div className="pt-4 space-y-4">
                          <div className="relative">
                          <Input
                              label={"Company Name"}
                              labelClasses={"!text-xs"}
                              inputType={"input"}
                              inputPlaceholder={"Company Name"}
                              inputValue={company_name}
                              setInput={setCompanyName}
                          />
                          </div>
                          <div className="relative">
                          <Select 
                            xPlacement={'left'} 
                            dropdownClass={'!w-full'} 
                            label={'Industry'}
                            selectedValue={industry} 
                            dropdownData={[
                              { _id: '', label: 'Select', value: '' }, 
                              ...industries.map((item) => (
                                { _id: item?._id, label: item?.name, value: item?._id }
                              ))
                            ]}
                            getSelectedValue={(e) => setIndustry(e._id)}
                            />
                          </div>
                          <div className="relative">
                          <Input
                              label={"Number of employees"}
                              labelClasses={"!text-xs"}
                              inputType={"input"}
                              inputPlaceholder={"Number of employees"}
                              inputValue={number_of_employees}
                              setInput={setNumberOfEmployees}
                          />
                          </div>
                          <div className="relative">
                            <Input
                              label={"Email"}
                              labelClasses={"!text-xs"}
                              inputType={"email"}
                              inputPlaceholder={"Email address"}
                              inputValue={email}
                              setInput={setEmail}
                            />
                          </div>
                          <div className="relative">
                          <Input
                              label={"Password"}
                              labelClasses={"!text-xs"}
                              inputType={"password"}
                              inputPlaceholder={"Your Password"}
                              inputValue={password}
                              setInput={setPassword}
                          />
                          </div>                        
                          <div className="relative flex justify-center">
                          <Button
                              buttonClasses=""
                              buttonLabelClasses=""
                              buttonType={"button"}
                              buttonIcon={(isSignup)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
                              buttonIconPosition={"left"}
                              buttonLabel={"Signup"}
                              functions={onSubmit}
                              buttonHasLink={false}
                              buttonDisabled={isSignup}
                          />
                          </div>
                      </div>
                      <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                          Already have a account?
                          <Link to={"/signin"} className="text-teal-500 font-semibold">Signin</Link>
                          here
                      </div>
                  </div>:
                  <div className="divide-y divide-slate-200 space-y-4">
                    <div className="relative">
                      <h1 className="text-xl font-semibold text-center text-slate-700">Verification code</h1>
                      <div className="text-sm text-slate-400 text-center font-light">
                        Please check your email for account verification
                      </div>
                    </div>
                    <div className="pt-4 space-y-4">
                      <div className="relative">
                        <Input
                            label={"Verification Code"}
                            labelClasses={"!text-xs"}
                            inputType={"number"}
                            inputPlaceholder={"Enter OTP"}
                            inputValue={otp}
                            setInput={setOtp}
                            errorType={"info"}
                            errorText={countDown}
                        />
                      </div>
                      <div className="relative flex justify-center gap-4">
                        <Button
                            buttonClasses=""
                            buttonLabelClasses=""
                            buttonType={"button"}
                            buttonIcon={(isVerify)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
                            buttonIconPosition={"left"}
                            buttonLabel={"Submit"}
                            functions={onVerify}
                            buttonHasLink={false}
                            buttonDisabled={isVerify}
                        />
                        <Button
                            buttonLabelClasses=""
                            buttonClasses={(isDisabled)?'!bg-slate-200 !text-slate-600 border border-slate-300 pointer-events-none':''} 
                            buttonType={"button"}
                            buttonIcon={(isResendOtp)?"fa-light fa-spinner fa-spin":"fa-light fa-clock"}
                            buttonIconPosition={"left"}
                            buttonLabel={"Resend OTP"}
                            functions={onResendOtp}
                            buttonHasLink={false}
                            buttonDisabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </>
      );
}

export default Signup;